import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import moment from 'moment'
import calendars from 'scoreboard/components/calendars'
import constants from 'scoreboard/components/constants'
import globals from 'scoreboard/components/globals'
import i18n from 'scoreboard/components/i18n'
import MultiTreeSelector from 'scoreboard/components/multi-tree-selector'
import OrgGardener from 'scoreboard/organizations/organizations-gardener'
import sendToExport from 'scoreboard/components/export/send-to-export'
import spectator from 'scoreboard/components/spectator'
import Wizard from 'scoreboard/components/wizard'
import DataPreview from 'scoreboard/components/data-preview'
import DateInput from 'scoreboard/components/date-input'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import * as dateRangeValidator from 'scoreboard/components/validators/date-range-validator-factory'
import momentHelper from 'scoreboard/components/moment-helper'
import periodTemplate from './metric-value-export-step2.hbs'
import FileFormat from 'scoreboard/imports/file-format'

// STEP 1
var OrgForm = MultiTreeSelector.extend({

	className: 'multi-tree-selector org-permissions-form metric-value-export-wizard',

	createGardener: function() {
		return new OrgGardener({
			descendants: true,
			section: constants.SECTION_SCORECARDS
		})
	},

	initialize(options) {
		options.bannerDescription = this._bannerText()
		this.options = options || {}
		this.options.data = this.options.data || {}

		// On initial load the current org must be selected by default, without descendants
		if (!this.options.data.orgSelections) {
			this.options.data.orgSelections = {}
			this.options.data.orgSelections[globals.orgId] = false
		}
		// For KPIs with only dataset series there is no calendar, so we pass
		// this to the server so it can use what the user was viewing
		this.options.data.calendarId = calendars.periodsById[globals.periodId].calendar.id
		options.allowCleanSubmission = !_.isEmpty(this.options.data.orgSelections)

		MultiTreeSelector.prototype.initialize.apply(this, arguments)
	},

	constructFormView: function () {
		const RequiredOrgFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new RequiredOrgFormView(this.formViewOptions())
	},

	render() {
		MultiTreeSelector.prototype.render.apply(this, arguments)
		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
		return this
	},

	// Invoked automatically by wizard
	saveState: function() {
		var data = this.options.data
		data.orgSelections = this.newSelections()
		this.options.wizard.saveState(data)
	},

	test: function() {
		return _.keys(this.newSelections()).length == 0 ?
			i18n.get('common.error.mustSelect.organization') : null
	},

	submit: function(e) {
		this.options.wizard.next()
	},

	oldSelections() {
		return this.options.data.orgSelections
	},

	context() {
		return {
			title: i18n.get('scorecards.exportValues') + ': ' + i18n.get('admin.generateDummyData.orgTree.select'),
			treeIcon: 'browse',
			treeIconClass: 'icon-browse',
			treeLabel: i18n.get('common.organization.organizations'),
			selectedLabel: i18n.get('report.metricComparisonReport.selectedOrganizations'),
			noneSelectedKey: 'admin.group.organizationPermissions.none',
			emptyTreeMessage: i18n.get('common.organization.noOrganizations'),
			cascadeHelpKey: 'admin.generateDummyData.orgTree.cascade',
			submitLabel: i18n.get('common.done')
		}
	},

	_bannerText() {
		return `${i18n.get('scorecards.exportValues.orgBanner.start')}
		<ul class="banner-list">
			<li>${i18n.get('scorecards.exportValues.orgBanner.item1')}</li>
			<li>${i18n.get('scorecards.exportValues.orgBanner.item2')}</li>
		</ul>
		${i18n.get('scorecards.exportValues.orgBanner.end')}`
	}
})

// STEP 2
const PeriodStep = Backbone.View.extend({

	tagName: 'form',

	/**
	 *
	 * @param {Object} options.data A data object shared by all wizard steps
	 * @param {Object} options.data.options A data object for this step only
	 */
	initialize(options) {
		this.options = options || {}
		this.data = _.get(this.options, 'data', {})

		if (_.isEmpty(this.data.start)) {
			this.data.start = moment().subtract(1, 'years')
				.format(momentHelper.isoDateFormat)
		}
		if (_.isEmpty(this.data.end)) {
			this.data.end = moment().format(momentHelper.isoDateFormat)
		}

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})
	},

	render() {
		this.$el.empty()
			.addClass('metric-value-export-step2')
			.append(periodTemplate())

		this.fileFormat = new FileFormat()
		this.$('.dialog-body-content').append(this.fileFormat.el)
		this.fileFormat.render()

		// setup start/archive controls
		this.startDateInput = new DateInput({
			el: this.$('.starts-on'),
			initialValue: this.data.start,
			required: true
		}).render()

		this.endDateInput = new DateInput({
			el: this.$('.ends-on'),
			initialValue: this.data.end,
			required: true,
			validator : dateRangeValidator.afterDateInput(
				DateInput.dateFormat(), this.startDateInput, 'admin.calendar.startDate')
		}).render()

		this.startDateInput.on('validated', () => this.endDateInput.validate())

		formHelper.writeToDom(this.data, this.el, true)

		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})

		this.formView.start({ isNew: true })
		this.endDateInput.validate()

		const format = this.options.data.format
		if (format) {
			this.$(`.format`).removeClass('is-selected')
			this.$(`.format[data-value='${format}']`).addClass('is-selected')
		}

		return this
	},

	// Invoked automatically when moving forward/backward in wizard
	saveState: function() {
		this.options.data.format = this.fileFormat.val()
		_.extend(this.options.data, formHelper.readFromDom(this.el))
		this.options.wizard.saveState(this.options.data)
	},

	submit() {
		this.saveState()
		return $.ajax({
			url: `api/scorecards/${spectator.getCurrentId()}/values/preview`,
			method: 'POST',
			data: JSON.stringify(this.options.data),
			success: (response) => {
				const {data, sheetCount} = response
				this.options.wizard.next(_.extend(this.options, {
					preview: {
						title: i18n.get('scorecards.exportValues'),
						label: i18n.get('common.preview'),
						data
					},
					sheetCount
				}))
			},
			error: (xhr) => this.formView.error(xhr)
		})
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.startDateInput, this.endDateInput], 'remove')
	}
})

// STEP 3
const PreviewStep = DataPreview.extend({

	render() {
		DataPreview.prototype.render.apply(this, arguments)
		const {sheetCount, preview} = this.options
		this.$('.banner').removeClass('is-not-displayed')
			.append(`<p>${i18n.get('scorecards.exportValues.step3.previewNotice')}</p>`)
		if (sheetCount > 1) {
			this.$('.banner').append(`<p class="paragraph">${i18n.get('scorecards.exportValues.step3.banner', sheetCount)}</p>`)
		} else if (_.size(_.get(preview, 'data.rows', [])) === 0) {
			this.$('.banner').append(`<p class="paragraph">${i18n.get('scorecards.exportValues.step3.noRecords')}</p>`)
		}
	},

	submit(e) {
		e.preventDefault()
		this.formView.primaryButton.loading()
		this.listenTo(this.options.wizard, 'done', this.trigger.bind(this, 'done'))
		this.options.wizard.finish()
	}
})

// WIZARD
const MetricValueExportWizard = Wizard.extend({

	initialize(options) {
		this.options = options || {}
		this.options.doneKey = 'scorecards.exportValues.done'
		var views = [ OrgForm, PeriodStep, PreviewStep ]
		Wizard.prototype.initialize.call(this, _.extend({ views: views }, this.options))
	},

	saveState(data) {
		this.options.data = data
	},

	finish() {
		const url = `scorecards/${spectator.getCurrentId()}/values`
		const options =  {
			method: 'POST',
			data: JSON.stringify(_.pick(this.options.data,
				['calendarId', 'orgSelections','start','end',
					'includeCalculatedValues', 'format'])),
			view: this
		}
		sendToExport.handleFileResponse(url, options)
	}
})



export default MetricValueExportWizard

MetricValueExportWizard.__filename__ = 'scorecards/overview/metric-value-export-wizard.js'
